"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchAutoCompoundingEvents = fetchAutoCompoundingEvents;
exports.calculateAprForInvestor = calculateAprForInvestor;
exports.calculateAprForPools = calculateAprForPools;
const decimal_js_1 = require("decimal.js");
const coins_js_1 = require("../../common/coins.js");
const maps_js_1 = require("../../common/maps.js");
const fetchEvents_js_1 = require("./fetchEvents.js");
const index_js_1 = require("../../index.js");
async function fetchAutoCompoundingEvents(params) {
    const eventTypesSet = new Set();
    // const rebalanceEventTypesSet = new Set<string>();
    const requiredPools = params.poolNames
        ? params.poolNames
        : Object.keys(maps_js_1.poolInfo);
    requiredPools.forEach((poolName) => {
        const eventType = maps_js_1.poolInfo[poolName].autoCompoundingEventType;
        const autobalanceOldEventType = maps_js_1.poolInfo[poolName].autobalanceOldAutoCompoundingEventType;
        if (eventType !== undefined && eventType !== null && eventType !== "") {
            eventTypesSet.add(eventType);
        }
        if (autobalanceOldEventType !== undefined &&
            autobalanceOldEventType !== null &&
            autobalanceOldEventType !== "") {
            eventTypesSet.add(autobalanceOldEventType);
        }
    });
    // for rebalance
    // if (params.poolNames) {
    //   params.poolNames.forEach((poolName) => {
    //     const eventType = poolInfo[poolName].rebalanceEventType;
    //     if (eventType !== undefined && eventType !== null && eventType !== "") {
    //       rebalanceEventTypesSet.add(eventType);
    //     }
    //   });
    // } else {
    //   // Iterate over all the values in poolInfo and add each autoCompoundingEventType to the Set
    //   Object.values(poolInfo).forEach((info) => {
    //     const eventType = info.rebalanceEventType;
    //     if (eventType !== undefined && eventType !== null && eventType !== "") {
    //       rebalanceEventTypesSet.add(eventType);
    //     }
    //   });
    // }
    const eventTypes = Array.from(eventTypesSet);
    // const rebalanceEventTypes = Array.from(rebalanceEventTypesSet);
    const eventsPromises = eventTypes.map(async (eventType) => {
        const events = (await (0, fetchEvents_js_1.fetchEvents)({
            startTime: params.startTime,
            endTime: params.endTime,
            eventTypes: [eventType],
            order: params.order,
        })).filter((e) => {
            if (params.poolNames) {
                return params.poolNames
                    .map((poolName) => maps_js_1.poolInfo[poolName].investorId)
                    .includes(e.investor_id);
            }
            else {
                return true;
            }
        });
        return events;
    });
    // const rebalanceEventsPromises = rebalanceEventTypes.map(async (eventType) => {
    //   const events = (
    //     await fetchEvents({
    //       startTime: params.startTime,
    //       endTime: params.endTime,
    //       eventTypes: [eventType],
    //     })
    //   ).filter((e) => {
    //     if (params.poolNames) {
    //       return params.poolNames
    //         .map((poolName) => poolInfo[poolName].investorId)
    //         .includes((e as AutoCompoundingEventNode).investor_id);
    //     } else {
    //       return true;
    //     }
    //   });
    //   return events;
    // });
    const events = (await Promise.all(eventsPromises)).flat();
    const autoCompoundingEvents = events.map((e) => {
        return e;
    });
    // const rebalanceEvents = (await Promise.all(rebalanceEventsPromises)).flat();
    // const rebalancingEvents = rebalanceEvents.map((e) => {
    //   return e as RebalanceEventNode;
    // });
    // const investorPoolMap = await getInvestorPoolMap();
    // for (const x of autoCompoundingEvents) {
    //   if (
    //     investorPoolMap.get(x.investor_id) &&
    //     poolInfo[investorPoolMap.get(x.investor_id)!].parentProtocolName ==
    //       "CETUS"
    //   ) {
    //     if (
    //       "total_amount_a" in x &&
    //       x.total_amount_a == 0n &&
    //       x.total_amount_b == 0n
    //     ) {
    //       for (const y of rebalancingEvents) {
    //         if (y.investor_id == x.investor_id && y.timestamp == x.timestamp) {
    //           // works if its guaranteed that for one timestamp there is only one rebalance for one pool
    //           x.total_amount_a = BigInt(y.amount_a_before);
    //           x.total_amount_b = BigInt(y.amount_b_before);
    //         }
    //       }
    //     }
    //   }
    // }
    return autoCompoundingEvents;
}
async function calculateAprForInvestor(events) {
    let totalGrowth = 0;
    let totalTimeSpan = 0;
    let apr = 0;
    try {
        // Sort events by timestamp to process them in order
        events.sort((a, b) => a.timestamp - b.timestamp);
        let previousTimestamp = events[0].timestamp; // Start with the timestamp of the first event
        let previousGrowthRate = 0;
        let previousTimeDiff = 0;
        let prevCompoundA = 0n;
        let prevCompoundB = 0n;
        const investorPoolMap = (0, maps_js_1.getInvestorPoolMap)();
        if (events.length > 0 &&
            "amount" in events[0] &&
            "total_amount_a" in events[0]
        // investorPoolMap
        //   .get(events[0].investor_id.toString())
        //   ?.toString()
        //   .includes("AUTOBALANCE")
        ) {
            let sumOfGrowths = new decimal_js_1.Decimal(0);
            const poolName = investorPoolMap.get(events[0].investor_id.toString());
            const c1 = maps_js_1.doubleAssetPoolCoinMap[poolName].coin1;
            const c2 = maps_js_1.doubleAssetPoolCoinMap[poolName].coin2;
            const [c1Price, c2Price] = await (0, index_js_1.getLatestPrices)([`${c1}/USD`, `${c2}/USD`], false);
            const coinTypeToCoin = maps_js_1.coinTypeMap;
            for (const event of events) {
                if ("amount" in event && "total_amount_a" in event) {
                    const reward = new decimal_js_1.Decimal(event.amount.toString());
                    const rewardType = event.coin_type.name.toString();
                    const rewardCoin = coinTypeToCoin["0x" + rewardType];
                    if (rewardCoin === undefined) {
                        continue;
                    }
                    const totalAmountA = new decimal_js_1.Decimal(event.total_amount_a.toString());
                    const totalAmountB = new decimal_js_1.Decimal(event.total_amount_b.toString());
                    const [price] = await (0, index_js_1.getLatestPrices)([`${rewardCoin}/USD`], false);
                    const rewardPrice = reward
                        .mul(price)
                        .div(Math.pow(10, coins_js_1.coinsList[rewardCoin].expo));
                    const baseAmountsPrice = totalAmountA
                        .mul(c1Price)
                        .div(Math.pow(10, coins_js_1.coinsList[c1].expo))
                        .plus(totalAmountB.mul(c2Price).div(Math.pow(10, coins_js_1.coinsList[c2].expo)));
                    if (baseAmountsPrice.gt(0)) {
                        sumOfGrowths = sumOfGrowths.plus(rewardPrice.div(baseAmountsPrice));
                    }
                }
            }
            return sumOfGrowths.mul(36500).toDecimalPlaces(4).toNumber();
        }
        // const matchInvestor =
        //   "0x3e8937974f3dac64eb8ee9f86a80ccc24852bd2f74d18753d071bbdad73a4c97"; // ALPHALEND-SUI-LOOP
        //       "0x681a30beb23d2532f9413c09127525ae5e562da7aa89f9f3498bd121fef22065"; // NAVI-USDC
        // // "0xa65eaadb556a80e4cb02fe35efebb2656d82d364897530f45dabc1e99d15a8a9"; // HASUI
        // ("0x227226f22bd9e484e541005916904ca066db1d42b8a80351800ef37b26c6cd89"); // AUSD
        // // "0xf43c62ca04c2f8d4583630872429ba6f5d8a7316ccb9552c86bb1fcf9dee3ce2"; // USDY
        // if (
        //   events &&
        //   events.length > 0 &&
        //   events[0].investor_id === matchInvestor
        // ) {
        //   console.log(
        //     "Compund Amount,Total Amount,GrowthRate,Timestamp,TimeDiff (Min)",
        //   );
        // }
        // if (
        //   events &&
        //   events.length > 0 &&
        //   events[0].investor_id === matchInvestor
        // ) {
        //   console.log(
        //     "Compund A,Total A,Compound B,Total B,Freebalance A,Freebalance B,GrowthA,GrowthB,AvgGrowth,Timestamp,TimeDiff (Min)",
        //   );
        // }
        for (const event of events) {
            // if (event.investor_id === matchInvestor) {
            //   console.log(event);
            // }
            // Calculate the time difference from the previous event
            let timeDiff = event.timestamp - previousTimestamp; // / (1000 * 60 * 60 * 24);
            // Calculate growth rate
            let growthRate = 0;
            if ("total_amount_a" in event &&
                "total_amount_b" in event &&
                "compound_amount_a" in event &&
                "cur_debt_a" in event) {
                let prevCompound = new decimal_js_1.Decimal(0);
                const poolName = investorPoolMap.get(events[0].investor_id.toString());
                const c1 = maps_js_1.doubleAssetPoolCoinMap[poolName].coin1;
                const c2 = maps_js_1.doubleAssetPoolCoinMap[poolName].coin2;
                const [c1Price, c2Price] = await (0, index_js_1.getLatestPrices)([`${c1}/USD`, `${c2}/USD`], false);
                const totalAmountUsd = new decimal_js_1.Decimal(c1Price)
                    .mul(new decimal_js_1.Decimal(event.total_amount_a.toString()).div(Math.pow(10, coins_js_1.coinsList[c1].expo)))
                    .plus(new decimal_js_1.Decimal(c2Price).mul(new decimal_js_1.Decimal(event.total_amount_b.toString()).div(Math.pow(10, coins_js_1.coinsList[c2].expo))));
                const totalAccruedInterestUsd = new decimal_js_1.Decimal(c1Price)
                    .mul(new decimal_js_1.Decimal(event.accrued_interest_a.toString()).div(Math.pow(10, coins_js_1.coinsList[c1].expo)))
                    .plus(new decimal_js_1.Decimal(c2Price).mul(new decimal_js_1.Decimal(event.accrued_interest_b.toString()).div(Math.pow(10, coins_js_1.coinsList[c2].expo))));
                const totalCompoundUsd = new decimal_js_1.Decimal(c1Price)
                    .mul(new decimal_js_1.Decimal(event.compound_amount_a.toString()).div(Math.pow(10, coins_js_1.coinsList[c1].expo)))
                    .plus(new decimal_js_1.Decimal(c2Price).mul(new decimal_js_1.Decimal(event.compound_amount_b.toString()).div(Math.pow(10, coins_js_1.coinsList[c2].expo))))
                    .minus(totalAccruedInterestUsd);
                if (totalAmountUsd.gt(0)) {
                    const totalDebtUsd = new decimal_js_1.Decimal(c1Price)
                        .mul(new decimal_js_1.Decimal(event.cur_debt_a.toString()).div(Math.pow(10, coins_js_1.coinsList[c1].expo)))
                        .plus(new decimal_js_1.Decimal(c2Price).mul(new decimal_js_1.Decimal(event.cur_debt_b.toString()).div(Math.pow(10, coins_js_1.coinsList[c2].expo))));
                    growthRate = Number(prevCompound
                        .div(totalAmountUsd.minus(totalDebtUsd).minus(prevCompound))
                        .plus(totalCompoundUsd.div(totalAmountUsd.minus(totalDebtUsd))));
                    prevCompound = new decimal_js_1.Decimal(0);
                }
                else {
                    prevCompound = prevCompound.plus(totalCompoundUsd);
                }
            }
            else if ("total_amount_a" in event &&
                "total_amount_b" in event &&
                "compound_amount_a" in event) {
                let growthA = 0;
                let growthB = 0;
                if (Number(event.total_amount_a) === 0) {
                    prevCompoundA += event.compound_amount_a;
                }
                else {
                    prevCompoundA = 0n;
                }
                if (prevCompoundA > 0n) {
                    growthA =
                        Number(event.total_amount_a) === 0
                            ? 0
                            : Number(event.compound_amount_a + prevCompoundA) /
                                Number(event.total_amount_a - prevCompoundA);
                }
                else {
                    growthA =
                        Number(event.total_amount_a) === 0
                            ? 0
                            : Number(event.compound_amount_a) / Number(event.total_amount_a);
                }
                if (Number(event.total_amount_b) === 0) {
                    prevCompoundB += event.compound_amount_b;
                }
                else {
                    prevCompoundB = 0n;
                }
                if (prevCompoundB > 0n) {
                    growthB =
                        Number(event.total_amount_b) == 0
                            ? 0
                            : Number(event.compound_amount_b + prevCompoundB) /
                                Number(event.total_amount_b - prevCompoundB);
                }
                else {
                    growthB =
                        Number(event.total_amount_b) == 0
                            ? 0
                            : Number(event.compound_amount_b) / Number(event.total_amount_b);
                }
                // if (
                //   event.investor_id ===
                //   "0xd060e81548aee885bd3d37ae0caec181185be792bf45412e0d0acccd1e0174e6"
                // ) {
                //   console.log(
                //     timeDiff / (1000 * 60),
                //     event.timestamp,
                //     event.timestamp - previousTimestamp,
                //   );
                // }
                // if (
                //   event.investor_id ===
                //   "0xd060e81548aee885bd3d37ae0caec181185be792bf45412e0d0acccd1e0174e6"
                // ) {
                //   console.log(
                //     event.compound_amount_a,
                //     event.total_amount_a,
                //     growthA,
                //     event.compound_amount_b,
                //     event.total_amount_b,
                //     growthB,
                //   );
                // }
                growthRate = (growthA + growthB) / 2; // Averaging growth rates for token A and B
                // if (event.investor_id === matchInvestor) {
                //   console.log(
                //     `${event.compound_amount_a},${event.total_amount_a},${event.compound_amount_b},${event.total_amount_b},${event.free_balance_a},${event.free_balance_b},${growthA},${growthB},${growthRate},${event.timestamp},${(event.timestamp - previousTimestamp) / (1000 * 60)}`,
                //   );
                // }
                if (Math.abs(growthA - growthB) > 0.5) {
                    // skip row, fill with previous event
                    growthRate = previousGrowthRate;
                    timeDiff = previousTimeDiff;
                }
                if (growthRate > 0.005) {
                    growthRate = 0;
                }
            }
            else if ("total_amount" in event) {
                let compoundAmount = Number(event.compound_amount);
                let totalAmount = Number(event.total_amount);
                if ("cur_total_debt" in event && "accrued_interest" in event) {
                    compoundAmount = Number(event.compound_amount - event.accrued_interest);
                    totalAmount = Number(event.total_amount - event.cur_total_debt);
                }
                // NaviAutoCompoundingEvent
                growthRate = isNaN(compoundAmount / totalAmount)
                    ? 0
                    : compoundAmount / totalAmount;
                const poolName = investorPoolMap.get(event.investor_id);
                const coinName = maps_js_1.singleAssetPoolCoinMap[poolName].coin;
                if (maps_js_1.poolInfo[investorPoolMap.get(event.investor_id)]
                    .parentProtocolName === "NAVI") {
                    growthRate = growthRate * Math.pow(10, 9 - coins_js_1.coinsList[coinName].expo);
                }
                // if (event.investor_id === matchInvestor) {
                //   console.log(
                //     `${event.compound_amount},${event.total_amount},${growthRate},${event.timestamp},${(event.timestamp - previousTimestamp) / (1000 * 60)}`,
                //   );
                // }
            }
            // Accumulate the time-weighted growth
            totalGrowth = (totalGrowth + 1) * (1 + growthRate) - 1;
            previousGrowthRate = growthRate;
            // Accumulate the total time span
            totalTimeSpan += timeDiff;
            previousTimeDiff = timeDiff;
            // Update the previous timestamp to the current event's timestamp
            previousTimestamp = event.timestamp;
        }
        apr = (totalGrowth / totalTimeSpan) * (1000 * 60 * 60 * 24 * 365) * 100;
    }
    catch (error) {
        console.error("Error calculating apr from events.", error);
        if (events.length > 0) {
            console.error("Investor-ID: ", events[0].investor_id);
        }
    }
    return apr;
}
async function calculateAprForInvestors(events) {
    const investorEvents = {};
    // Step 1: Segregate events by investor_id
    for (const event of events) {
        const investorId = event.investor_id;
        if (!investorEvents[investorId]) {
            investorEvents[investorId] = [];
        }
        investorEvents[investorId].push(event);
    }
    // Step 2: Calculate APR for each event and aggregate for each investor
    const aprPromises = [];
    for (const investorId in investorEvents) {
        const investorEventList = investorEvents[investorId];
        // Push a promise that resolves to an object containing the investorId and the corresponding APR
        aprPromises.push(calculateAprForInvestor(investorEventList).then((apr) => ({
            investorId,
            apr,
        })));
    }
    // Resolve all promises and map them to the corresponding APR
    const aprs = await Promise.all(aprPromises);
    // Convert the array of results into an object mapping investorId to APR
    const aprMap = aprs.reduce((map, result) => {
        map[result.investorId] = result.apr;
        return map;
    }, {});
    return aprMap;
}
async function calculateAprForPools(events) {
    const aprMap = {};
    const investorPoolNameMap = await (0, maps_js_1.getInvestorPoolMap)();
    const investorAprMap = await calculateAprForInvestors(events);
    for (const investorId in investorAprMap) {
        const poolName = investorPoolNameMap.get(investorId);
        if (poolName) {
            aprMap[poolName] = investorAprMap[investorId];
        }
    }
    return aprMap;
}
//# sourceMappingURL=fetchAutoCompoundingEvents.js.map